import { RouteRecordRaw } from 'vue-router'
import { Layout, getParentLayout } from '@/utils/routerHelper'

const systemRoutes: RouteRecordRaw[] = [
  {
    path: '/system',
    component: Layout,
    redirect: '/system/manage/manager',
    name: 'System',
    meta: {
      title: '系统设置',
      icon: 'vi-uil:setting',
      alwaysShow: true
    },
    children: [
      {
        path: 'manage',
        name: 'SystemManage',
        component: getParentLayout(),
        meta: {
          title: '管理员',
          icon: 'mdi-tune',
          alwaysShow: true
        },
        children: [
          {
            path: 'module',
            component: () => import('@/views/System/Manage/Module.vue'),
            name: 'SystemModule',
            meta: { title: '功能', icon: 'mdi-puzzle' }
          },
          {
            path: 'manager',
            component: () => import('@/views/System/Manage/Manager.vue'),
            name: 'SystemManager',
            meta: { title: '管理员', icon: 'mdi-shield-account' }
          },
          {
            path: 'menu',
            component: () => import('@/views/System/Manage/Menu.vue'),
            name: 'SystemMenu',
            meta: { title: '菜单管理', icon: 'mdi-menu' }
          },
          {
            path: 'role',
            component: () => import('@/views/System/Manage/Role.vue'),
            name: 'SystemRole',
            meta: { title: '角色管理', icon: 'mdi-account-key' }
          },
          {
            path: 'permission',
            component: () => import('@/views/System/Manage/Permission.vue'),
            name: 'SystemPermission',
            meta: { title: '权限测试页', icon: 'mdi-lock-check' }
          }
        ]
      },
      {
        path: 'setting',
        name: 'SystemSetting',
        component: getParentLayout(),
        meta: {
          title: '设置',
          icon: 'mdi-cog',
          alwaysShow: true
        },
        children: [
          {
            path: 'op-log',
            component: () => import('@/views/System/Setting/OperationLog.vue'),
            name: 'OperationLog',
            meta: { title: '操作日志', icon: 'mdi-history' }
          },
          {
            path: 'login-log',
            component: () => import('@/views/System/Setting/LoginLog.vue'),
            name: 'LoginLog',
            meta: { title: '登录日志', icon: 'mdi-login-variant' }
          },
          {
            path: 'config',
            component: () => import('@/views/System/Setting/SystemConfig.vue'),
            name: 'SystemConfig',
            meta: { title: '系统配置', icon: 'mdi-tune-variant' }
          },
          {
            path: 'country',
            component: () => import('@/views/System/Country/Index.vue'),
            name: 'SystemCountry',
            meta: { title: '国家配置', hidden: true }
          }
        ]
      }
    ]
  }
]

export default systemRoutes
